(() => {
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  function initCustomOptions(root) {
    if (root.dataset.customOptionsInitialized === 'true') return;
    root.dataset.customOptionsInitialized = 'true';

    const panels = Array.from(root.querySelectorAll('[data-custom-options-panel]'));
    const triggers = Array.from(root.querySelectorAll('[data-custom-options-trigger]'));
    if (!panels.length) return;

    const homeMarker = document.createComment('custom-options-home');
    root.parentNode.insertBefore(homeMarker, root);
    const discoveryHintKey = `custom-options-hint:${window.location.pathname}`;

    function hasSeenDiscoveryHint() {
      try {
        return window.sessionStorage.getItem(discoveryHintKey) === 'seen';
      } catch (_error) {
        return false;
      }
    }

    function dismissDiscoveryHint() {
      triggers[0]?.classList.remove('is-discovery-hint');
      try {
        window.sessionStorage.setItem(discoveryHintKey, 'seen');
      } catch (_error) {
        // The hint still disappears if storage is unavailable.
      }
    }

    if (!hasSeenDiscoveryHint()) triggers[0]?.classList.add('is-discovery-hint');

    const panelFor = (category) => panels.find((panel) => panel.dataset.customOptionsPanel === category);

    function activateSubcategory(panel, blockId) {
      const subcategoryTriggers = Array.from(panel.querySelectorAll('[data-custom-options-subcategory]'));
      const subpanels = Array.from(panel.querySelectorAll('[data-custom-options-subpanel]'));
      const targetId = blockId || subcategoryTriggers[0]?.dataset.customOptionsSubcategory;

      subcategoryTriggers.forEach((trigger) => {
        const isActive = trigger.dataset.customOptionsSubcategory === targetId;
        trigger.setAttribute('aria-selected', String(isActive));
        if (isActive && panel.classList.contains('is-mobile-active')) {
          trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
      subpanels.forEach((subpanel) => {
        subpanel.classList.toggle('is-mobile-subpanel-active', subpanel.dataset.customOptionsSubpanel === targetId);
      });
      panel.querySelector('.accordion-content')?.scrollTo({ top: 0 });
    }

    panels.forEach((panel) => {
      panel.querySelectorAll('[data-custom-options-subcategory]').forEach((trigger) => {
        trigger.addEventListener('click', () => activateSubcategory(panel, trigger.dataset.customOptionsSubcategory));
      });
    });

    function closeMobilePanel({ restoreFocus = false } = {}) {
      const activeTrigger = triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true');

      panels.forEach((panel) => {
        panel.classList.remove('is-mobile-active');
        panel.open = false;
      });
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));

      if (restoreFocus) activeTrigger?.focus();
    }

    function openMobilePanel(category) {
      const panel = panelFor(category);
      const trigger = triggers.find((item) => item.dataset.customOptionsTrigger === category);
      if (!panel || !trigger) return;

      const isAlreadyOpen = panel.classList.contains('is-mobile-active');
      closeMobilePanel();
      if (isAlreadyOpen) return;

      panel.open = true;
      panel.classList.add('is-mobile-active');
      trigger.setAttribute('aria-expanded', 'true');
      activateSubcategory(panel);
    }

    function configureForViewport() {
      panels.forEach((panel) => panel.classList.remove('is-mobile-active'));
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));

      if (mobileMedia.matches) {
        const productGrid = root.closest('.product');
        const productInfo = productGrid?.querySelector(':scope > .product__info-wrapper');
        if (productGrid && productInfo) productGrid.insertBefore(root, productInfo);
        panels.forEach((panel) => {
          panel.open = false;
          activateSubcategory(panel);
        });
      } else {
        homeMarker.parentNode?.insertBefore(root, homeMarker.nextSibling);
        panels.forEach((panel, index) => {
          panel.open = index === 0;
          panel.querySelectorAll('[data-custom-options-subpanel]').forEach((subpanel) => {
            subpanel.classList.remove('is-mobile-subpanel-active');
          });
        });
      }
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        dismissDiscoveryHint();
        openMobilePanel(trigger.dataset.customOptionsTrigger);
      });
    });

    panels.forEach((panel) => {
      panel.querySelector('summary')?.addEventListener('click', () => {
        if (!mobileMedia.matches && !panel.open) {
          window.scrollTo({ top: 50, behavior: 'smooth' });
        }
      });

      panel.addEventListener('toggle', () => {
        if (!mobileMedia.matches) {
          if (panel.open) {
            panels.forEach((other) => {
              if (other !== panel) other.open = false;
            });
          }
          return;
        }

        if (!panel.open && panel.classList.contains('is-mobile-active')) {
          closeMobilePanel();
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileMedia.matches) {
        closeMobilePanel({ restoreFocus: true });
      }
    });

    mobileMedia.addEventListener('change', configureForViewport);
    configureForViewport();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-custom-options]').forEach(initCustomOptions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
